import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';

import { useShareStory } from './hooks/useShareStory';
import { httpClient } from '../../services/httpClient/httpClient';
import { getUserIncentiveCampaigns } from '../../store/slices/rewards';
import { useAppDispatch, useTypedSelector } from '../../store/store';

import { UploadProgressBar } from '../../common/components/UploadProgressBar/UploadProgressBar';
import { NavigationPanel } from '../../common/components/NavigationPanel/NavigationPanel';
import { useSharePageStyles } from './SharePage.styles';
import { IncentiveBlock } from '../../common/components/IncentiveBlock/IncentiveBlock';
import { GetUserQuestions } from '../../store/slices/ui';
import { useTrackEvent } from '../../common/hooks/useTrackEvent';
import { EventNames } from '../../common/constants/constants';
import { getStoryById } from '../../store/slices/stories';
import { useClientType } from '../../services/hooks/useClientType';

const SharePage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { id: storyId } = useParams<{ id: string }>();
  const {
    accountAttributes: { properties },
  } = useTypedSelector((state) => state.account);
  const hideBackgroundImages = properties?.['webapp.config']?.hideBackgroundImages;
  const { isUVMClient } = useClientType();
  const background = isUVMClient ? '#C3D8E5' : hideBackgroundImages ? 'white' : `url(/mattrogers05.png)`;
  const styles = useSharePageStyles({ background });
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    const userId = httpClient.getUserId();
    if (userId) {
      dispatch(getUserIncentiveCampaigns({ userId }));
      dispatch(GetUserQuestions(userId)).then(() => {
        setHasLoaded(true);
      });
    } else {
      setHasLoaded(true);
    }
  }, [dispatch]);

  const { shareStory, isLoading, isShareStoryLoading } = useShareStory({
    storyId,
    refetchUntilModerated: true,
  });

  useEffect(() => {
    if (!isShareStoryLoading && !shareStory) {
      dispatch(getStoryById({ id: storyId }));
    }
  }, [shareStory, isShareStoryLoading]);

  const { trackEvent } = useTrackEvent();

  const { currentCampaign } = useTypedSelector((state) => state.rewards);
  const { isLoading: isQuestionsLoading, items } = useTypedSelector((state) => state.ui.questions);

  useEffect(() => {
    if (items.length > 1) {
      trackEvent({ action: EventNames.complete_screen_page_view });
    }
  }, [items]);

  const isStoryLoading = isLoading || !shareStory || isQuestionsLoading || !hasLoaded;
  if (isStoryLoading) return <Box className={styles.container}> </Box>;

  return (
    <>
      <Box position="fixed" bottom="0" width="100vw">
        <NavigationPanel
          activeIndex={currentCampaign?.welcomeVideoUrl && currentCampaign?.showWelcomeVideo ? 2 : 1}
          isSharePage={true}
        />
      </Box>
      <Box className={styles.container}>
        <UploadProgressBar forceShowUploadComplete />
        <IncentiveBlock showQuestions={true} showTopBanner={true} isCompleteScreen={true} />
      </Box>
    </>
  );
};

export default SharePage;
